export const SESSION_STORAGE_KEYS = Object.freeze({ IGNORE_MAINTENANCE_BANNER: 'ignoreMaintenanceBanner' })
